export default __webpack_public_path__ + "static/media/triple-decker.afe00bc2.svg";